import axios from 'axios';
import { getBatonBaseUrl, getOrderMangerBaseUrl } from '../constants';
// May be this should be part of baton client
export const getV0BatonsByKey = async (key, accessToken, env) => {
    const batonResponse = await axios.get(`${getBatonBaseUrl(env)}/v0/batons`, {
        headers: { 'Authorization': `Bearer ${accessToken}`, 'Cache-Control': 'no-cache' },
        params: {
            key: key
        }
    });
    return batonResponse.data;
};
export const getAllV0BatonsForItem = async (fulfillmentGroupId, itemServiceUrl, accessToken, env) => {
    const batonList = [];
    // Fetch items with key as order manger url (polling batons)
    const orderMangerUrlForFulfillmentGroupId = `${getOrderMangerBaseUrl(env)}/v2/fulfillmentrequests?fulfillmentGroupId=${fulfillmentGroupId}`;
    const batonByOrderManagerUrl = getV0BatonsByKey(orderMangerUrlForFulfillmentGroupId, accessToken, env);
    // Fetch items with key as item service url (cancellation & Print Job batons)
    const batonByItemUrl = getV0BatonsByKey(itemServiceUrl, accessToken, env);
    const [batonByOrderManagerUrlResponse, batonByItemUrlResponse] = await Promise.all([batonByOrderManagerUrl, batonByItemUrl]);
    batonList.push(...batonByOrderManagerUrlResponse.batons);
    batonList.push(...batonByItemUrlResponse.batons);
    return batonList;
};
